module.exports = __webpack_public_path__ + "img/bsn_6.ee8f0c7a.png";